var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01_AtAGlance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_01",
    transform: "translate(-95.000000, -167.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(96.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Alert/Tertiairy",
    transform: "translate(4.000000, 3.000000)",
    fill: "#DB3766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alert_Tertiairy",
    transform: "translate(1.040000, -1.040000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Combined-Shape",
    transform: "translate(5.165981, 7.628228) rotate(15.000000) translate(-5.165981, -7.628228) ",
    points: "6.52138912 0.663942608 1.68383864 8.73068276 4.92359341 8.73068276 3.81057388 14.592514 8.64812435 6.52577383 5.40836963 6.52577383"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    stroke: "#DB3766",
    cx: 10,
    cy: 10,
    r: 10.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.ad884ef5ffc3ef12072f4154872f7787.svg";
export { ForwardRef as ReactComponent };